import { motion } from "framer-motion";

export const About = () => (
  <section id="company" data-testid="company-section" className="py-24 md:py-32 px-6 md:px-12 border-t border-black/10">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18 }}
        className="lg:col-span-3 font-mono text-xs uppercase tracking-[0.3em] text-[#0891B2]"
      >
        Our Company
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18, delay: 0.1 }}
        className="lg:col-span-9"
      >
        <h2 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-zinc-950 leading-tight max-w-4xl">
          Harris Holt is an industry and technology leader serving government
          and commercial customers with smarter, more efficient digital and
          mission innovations.
        </h2>
        <p className="mt-8 text-[19px] leading-relaxed text-zinc-600 max-w-3xl">
          We pair deep mission understanding with the best of commercial
          technology — helping customers modernize faster, operate more
          securely, and deliver outcomes that endure.
        </p>
      </motion.div>
    </div>
  </section>
);
